import React from "react";
import RadioField from "./RadioField";
import { checkboxesChoicesType } from "../../types/common";
import { Control, FieldValues } from "react-hook-form";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface RadioFieldsetProps<T extends FieldValues> {
	control: Control<T>;
	criterionKey: string;
	fieldsetDefinition: {
		checkboxChoices?: checkboxesChoicesType;
		inputLabel?: string;
		radioKey: string;
		radioLabel: string;
		radioTitle: string;
	}[];
	onUpdateField?: (criterionKey: string, radioKey: string) => void;
	setFocus?: (inputKey: string) => void;
	setValue?: (criterionKey: string, radioKey: string) => void;
}

export default function RadioFieldset({
	control,
	criterionKey,
	fieldsetDefinition,
	onUpdateField,
	setFocus,
	setValue,
}: RadioFieldsetProps<any>) {
	return fieldsetDefinition.map((field) => {
		const {
			checkboxChoices,
			inputLabel,
			radioKey,
			radioLabel,
			radioTitle,
		} = field;

		return (
			<RadioField
				control={control}
				checkboxChoices={checkboxChoices}
				criterionKey={criterionKey}
				inputLabel={inputLabel}
				key={radioKey}
				onUpdateField={onUpdateField}
				radioKey={radioKey}
				radioLabel={radioLabel}
				radioTitle={radioTitle}
				setFocus={setFocus}
				setValue={setValue}
			/>
		);
	});
}
